import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import moment from 'moment';
import axios from 'axios';
import { MultiSelect } from 'primereact/multiselect';
import CBMediaQuery from '../shared/CBMediaQuery';
import CBSearchInput from '../shared/CBSearchInput';
import CBDatePickerInput from '../shared/CBDatePickerInput';
import CBSelectFilters from '../shared/CBSelectFilters';
import CBLabelAndCheckbox from '../shared/CBLabelAndCheckbox';
import CBButtonGarageAction from '../shared/CBButtonGarageAction';
import CBMobileCard from '../shared/CBMobileCard';
import CBMobileSortSelect from '../shared/CBMobileSortSelect';
import VehicleListTh from '../OrganizationGarageView/OrganizationGarageComponents/VehicleListTh';
import VehicleListTd from '../OrganizationGarageView/OrganizationGarageComponents/VehicleListTd';
import CreateChainMessageModal from './components/CreateChainMessageModal';
import ChainMessageDetailModal from '../MessagesView/MessagesViewComponents/ChainMessageDetailModal';
import { finnishDateFormat, getStyle, styleMerge, SERVICE_CHAIN } from '../../utils/utils';
import { API_URL } from '../../config';
import {
  fetchMaintenanceReservations as _fetchMaintenanceReservations,
  fetchChainCareServices as _fetchChainCareServices,
  fetchChainMemberships as _fetchChainMemberships,
  fetchReservationParts as _fetchReservationParts,
} from '../../actions/chainActions';
var SELECTED_FIELDS_KEY = 'selectedMaintenanceReservationFields';


function getPercentageColor(pct) {
  if (pct >= 80) return '#4CAF50';
  if (pct >= 50) return '#FF9800';
  return '#F44336';
}

function formatPrice(value) {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('fi-FI', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) + ' \u20AC';
}

// show_maintenance_prices=False on the chain hides all prices and the
// price-derived chain-% in the chain portal (the server strips the values;
// this hides the empty columns/labels).
function chainShowsPrices(user, selectedChainId) {
  var chains = user && user.chains ? user.chains : [];
  var chainObj = chains.find(function (c) { return c.id === selectedChainId; });
  return !chainObj || chainObj.show_maintenance_prices !== false;
}

function renderReservationPartRow(part, isChainPart, tooltipText, showPrices) {
  return (
    <div key={part.id} style={partRowStyles.container}>
      <div style={partRowStyles.leftSection}>
        {isChainPart ? (
          <span style={partRowStyles.chainBadge} title={tooltipText}>{'\u2713'}</span>
        ) : (
          <span style={partRowStyles.otherBadge} title={tooltipText}>{'\u2717'}</span>
        )}
        <span style={partRowStyles.name}>{part.name || part.product_code}</span>
        {part.quantity != null && (
          <span style={partRowStyles.amount}>
            {part.quantity} kpl
          </span>
        )}
      </div>
      <div style={partRowStyles.rightSection}>
        {isChainPart && part.product_code && (
          <span style={partRowStyles.typeCode}>{part.product_code}</span>
        )}
        {showPrices !== false && (
          <span style={partRowStyles.price}>
            {part.total_price != null
              ? formatPrice(part.total_price)
              : '-'}
          </span>
        )}
      </div>
    </div>
  );
}


class ChainUpcomingMaintenancesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      ordering: 'start',
      filters: {},
      page: 1,
      fields: [],
      selectedFields: [],
      selectedReservations: [],
      expandedRowId: null,
      approvalModalIsOpen: false,
      singleApprovalReservation: null,
      singleApprovalModalIsOpen: false,
      detailMessage: null,
      detailModalIsOpen: false,
    };
    this.tableScrollRef = React.createRef();
    this.topScrollRef = React.createRef();
    this._isSyncingScroll = false;
  }

  componentDidMount() {
    this.syncTopScrollWidth();
    if (typeof ResizeObserver !== 'undefined' && this.tableScrollRef.current) {
      this._resizeObserver = new ResizeObserver(this.syncTopScrollWidth);
      this._resizeObserver.observe(this.tableScrollRef.current);
    }
  }

  componentWillUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  syncTopScrollWidth = () => {
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      var inner = this.topScrollRef.current.firstChild;
      if (inner) {
        inner.style.width = this.tableScrollRef.current.scrollWidth + 'px';
      }
    }
  };

  handleTopScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      this.tableScrollRef.current.scrollLeft = this.topScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  handleTableScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.topScrollRef.current && this.tableScrollRef.current) {
      this.topScrollRef.current.scrollLeft = this.tableScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  componentWillMount() {
    const { t, selectedChainId } = this.props;

    // Define available columns
    var allFields = [
      { label: t('headingRegNr'), value: 'reg_nr' },
      { label: t('headingOrganization'), value: 'organization_name' },
      { label: t('headingWorkshop'), value: 'workshop_name' },
      { label: t('headingStartTime'), value: 'start' },
      { label: t('headingEndTime'), value: 'end' },
      { label: t('headingDescription'), value: 'description' },
      { label: t('headingCreatedAt'), value: 'autofutur_created' },
      { label: t('headingBooker'), value: 'user_id' },
      { label: t('headingPartsOrdered'), value: 'part_items_ordered' },
      { label: t('headingLatestKm'), value: 'latest_km' },
      { label: t('headingLastMaintenance'), value: 'last_maintenance' },
      { label: t('headingReservationPartsPercentage'), value: 'chain_parts_percentage' },
      { label: t('headingApprovalStatus'), value: 'approval_status' },
      { label: t('headingNewApprovalRequest'), value: 'new_approval_request' },
    ];

    // Load saved column selection or use defaults
    var savedFields = localStorage.getItem(SELECTED_FIELDS_KEY);
    var selectedFields = savedFields
      ? JSON.parse(savedFields)
      : ['reg_nr', 'organization_name', 'workshop_name', 'start', 'description'];

    this.setState({
      fields: allFields,
      selectedFields: selectedFields,
    });

    if (selectedChainId) {
      this.props.fetchChainMemberships(selectedChainId);
      this.props.fetchChainCareServices(selectedChainId);
      var savedState = this.loadListStateFromStorage();
      if (savedState) {
        var search = savedState.search;
        var savedOrdering = savedState.ordering;
        var filters = savedState.filters;
        var page = savedState.page;
        this.setState({
          search: search || '',
          ordering: savedOrdering || this.state.ordering,
          filters: filters || this.state.filters,
          page: page || 1,
        }, () => {
          this.refetchReservations();
        });
      } else {
        this.refetchReservations();
      }
    }
  }

  componentDidUpdate(prevProps) {
    this.syncTopScrollWidth();
    const { selectedChainId } = this.props;

    if (selectedChainId !== prevProps.selectedChainId && selectedChainId) {
      this.props.fetchChainMemberships(selectedChainId);
      this.props.fetchChainCareServices(selectedChainId);
      var savedState = this.loadListStateFromStorage();
      if (savedState) {
        var search = savedState.search;
        var savedOrdering = savedState.ordering;
        var filters = savedState.filters;
        var page = savedState.page;
        this.setState({
          search: search || '',
          ordering: savedOrdering || this.state.ordering,
          filters: filters || this.state.filters,
          page: page || 1,
        }, () => {
          this.refetchReservations();
        });
      } else {
        this.setState({ page: 1 }, () => this.refetchReservations());
      }
    }
  }

  getCompanyScopeKey = () => {
    const { selectedChainId } = this.props;
    return 'maintenanceReservationListState:chain:' + (selectedChainId || 'none');
  }

  saveListStateToStorage = () => {
    const { search, ordering, filters, page } = this.state;
    var key = this.getCompanyScopeKey();
    try {
      localStorage.setItem(key, JSON.stringify({ search: search, ordering: ordering, filters: filters, page: page }));
    } catch (e) {}
  }

  loadListStateFromStorage = () => {
    var key = this.getCompanyScopeKey();
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  refetchReservations = () => {
    const { fetchMaintenanceReservations, selectedChainId } = this.props;
    const { search, ordering, filters } = this.state;

    if (!selectedChainId) return;

    var params = {
      search: search,
      ordering: ordering,
    };
    var filterKeys = Object.keys(filters);
    for (var i = 0; i < filterKeys.length; i++) {
      params[filterKeys[i]] = filters[filterKeys[i]];
    }

    fetchMaintenanceReservations(selectedChainId, params);
    this.saveListStateToStorage();
  };

  changeSearchTerms = (value) => {
    this.setState({
      search: value,
    }, () => {
      this.saveListStateToStorage();
    });
  }

  changeFilterTerms = (newFilters) => {
    this.setState({
      filters: { ...this.state.filters, ...newFilters },
      page: 1,
    }, () => {
      this.saveListStateToStorage();
      this.refetchReservations();
    });
  }

  changeOrdering = (clickedOrdering) => {
    const { ordering } = this.state;
    var newOrdering;
    if (ordering === clickedOrdering) {
      newOrdering = '-' + ordering;
    } else if ('-' + ordering === clickedOrdering) {
      newOrdering = 'start';
    } else {
      newOrdering = clickedOrdering;
    }
    this.setState({
      ordering: newOrdering,
      page: 1,
    }, () => {
      this.saveListStateToStorage();
      this.refetchReservations();
    });
  };

  getOrderingSymbol = (columnName) => {
    const { ordering } = this.state;
    if (ordering === columnName) {
      return '/img/down_arrow_icon.svg';
    } else if (ordering === '-' + columnName) {
      return '/img/up_arrow_icon.svg';
    }
    return undefined;
  };

  setSelectedFields = (newSelectedFields) => {
    this.setState({ selectedFields: newSelectedFields });
    localStorage.setItem(SELECTED_FIELDS_KEY, JSON.stringify(newSelectedFields));
  };

  getVisibleColumnCount = () => {
    var { selectedFields } = this.state;
    // checkbox + each selected field + settings column
    return 2 + selectedFields.length;
  }

  getWorkshopOptions = () => {
    const { chainMemberships, t } = this.props;
    var options = [
      { value: '', label: t('filterAllWorkshops') },
    ];

    if (chainMemberships && chainMemberships.length > 0) {
      chainMemberships.forEach(function (membership) {
        if (membership.workshop && membership.workshop.id) {
          options.push({
            value: String(membership.workshop.id),
            label: membership.workshop.name,
          });
        }
      });
    }

    return options;
  }

  getOrganizationOptions = () => {
    const { chainCareServices, t } = this.props;
    var options = [
      { value: '', label: t('filterAllCustomers') },
    ];
    var seen = {};

    if (chainCareServices && chainCareServices.length > 0) {
      chainCareServices.forEach(function (cs) {
        var orgId = cs.organization;
        if (orgId && !seen[orgId]) {
          seen[orgId] = true;
          options.push({
            value: String(orgId),
            label: cs.organization_name || '-',
          });
        }
      });
    }

    return options;
  }

  toggleReservationSelected = (reservationId) => {
    const { selectedReservations } = this.state;
    if (selectedReservations.includes(reservationId)) {
      this.setState({ selectedReservations: selectedReservations.filter(function (id) { return id !== reservationId; }) });
    } else {
      this.setState({ selectedReservations: selectedReservations.concat([reservationId]) });
    }
  };

  selectAllChanged = () => {
    const { maintenanceReservations } = this.props;
    const { selectedReservations } = this.state;
    var allChecked = maintenanceReservations && selectedReservations.length === maintenanceReservations.length;
    if (allChecked) {
      this.setState({ selectedReservations: [] });
    } else {
      var allIds = maintenanceReservations ? maintenanceReservations.map(function (r) { return r.id; }) : [];
      this.setState({ selectedReservations: allIds });
    }
  };

  openApprovalRequestModal = () => {
    this.setState({ approvalModalIsOpen: true });
  };

  closeApprovalRequestModal = () => {
    this.setState({ approvalModalIsOpen: false, selectedReservations: [] });
  };

  openSingleApprovalModal = (reservation) => {
    this.setState({ singleApprovalReservation: reservation, singleApprovalModalIsOpen: true });
  };

  closeSingleApprovalModal = () => {
    this.setState({ singleApprovalReservation: null, singleApprovalModalIsOpen: false });
  };

  openApprovalDetailModal = (messageId) => {
    var _this = this;
    var selectedChainId = this.props.selectedChainId;
    if (!selectedChainId) return;
    axios.get(API_URL + '/uiapi/1/cc_message/' + messageId + '/?chain_id=' + selectedChainId)
      .then(function (response) {
        _this.setState({ detailMessage: response.data, detailModalIsOpen: true });
      })
      .catch(function () {});
  };

  closeApprovalDetailModal = () => {
    this.setState({ detailMessage: null, detailModalIsOpen: false });
  };

  // Chain approvals (workshop -> ketjujohto) and customer approvals (workshop ->
  // fleet customer) side by side; the latter were serialized but never shown here.
  getApprovalLabelSets = () => {
    const { t } = this.props;
    return {
      chain: { pending: t('approvalPending'), approved: t('approvalApproved'), rejected: t('approvalRejected') },
      customer: {
        pending: t('approvalSentToCustomer'),
        approved: t('approvalCustomerApproved'),
        rejected: t('approvalCustomerRejected'),
      },
    };
  };

  getApprovalBadge = (reservation) => {
    var _this = this;
    var colors = { pending: '#e67e22', approved: '#27ae60', rejected: '#e74c3c' };
    var labelSets = this.getApprovalLabelSets();
    var chainRequests = reservation.approval_requests || [];
    var customerRequests = reservation.customer_approval_requests || [];
    if (!chainRequests.length && !customerRequests.length) {
      return '-';
    }
    var renderRow = function (ar, labels, keyPrefix) {
      var sentAt = ar.created_at ? moment(ar.created_at).format('D.M.') : '';
      return (
        <span
          key={keyPrefix + ar.id}
          className='opacity-on-hover'
          title={ar.subject || ''}
          style={{ color: colors[ar.approval_status] || '#fff', fontWeight: 'bold', fontSize: 12, cursor: 'pointer' }}
          onClick={function (e) { e.stopPropagation(); _this.openApprovalDetailModal(ar.id); }}
        >
          {labels[ar.approval_status] || ar.approval_status}{sentAt ? ' ' + sentAt : ''}
        </span>
      );
    };
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {chainRequests.map(function (ar) { return renderRow(ar, labelSets.chain, 'chain-'); })}
        {customerRequests.map(function (ar) { return renderRow(ar, labelSets.customer, 'customer-'); })}
      </div>
    );
  };

  getSelectedReservationObjects = () => {
    const { maintenanceReservations } = this.props;
    const { selectedReservations } = this.state;
    if (!maintenanceReservations) return [];
    return maintenanceReservations.filter(function (r) { return selectedReservations.includes(r.id); });
  };

  toggleRow = (reservation) => {
    var { expandedRowId } = this.state;

    // Collapse if clicking the already-expanded row
    if (expandedRowId === reservation.id) {
      this.setState({ expandedRowId: null });
      return;
    }

    // Expand the new row
    this.setState({ expandedRowId: reservation.id });
    this.ensureReservationPartsLoaded(reservation);
  };

  // Lazily fetch the reservation parts. Shared by the desktop expandable row and
  // the mobile card's expand toggle (onExpand).
  ensureReservationPartsLoaded = (reservation) => {
    var { selectedChainId, reservationParts } = this.props;
    if (!reservation.work_order_nr) {
      return;
    }
    var cached = reservationParts && reservationParts[reservation.id];
    if (cached && (cached.data || cached.loading)) {
      return;
    }
    if (selectedChainId) {
      this.props.fetchReservationParts(reservation.id, selectedChainId);
    }
  };

  renderExpandedParts = (reservation, stacked) => {
    var { t, reservationParts } = this.props;

    if (!reservation.work_order_nr) {
      return (
        <div style={expandedStyles.loading}>
          <p>{t('partsNotEnriched')}</p>
        </div>
      );
    }

    var cached = reservationParts && reservationParts[reservation.id];

    if (!cached || cached.loading) {
      return (
        <div style={expandedStyles.loading}>
          <p>{t('loadingParts')}</p>
        </div>
      );
    }

    if (cached.error) {
      return (
        <div style={expandedStyles.loading}>
          <p>{t('errorLoadingParts')}</p>
        </div>
      );
    }

    var parts = cached.data || [];
    var chainParts = parts.filter(function (p) { return p.is_chain_part === true; });
    var otherParts = parts.filter(function (p) { return p.is_chain_part !== true; });

    // On mobile the two sections stack vertically instead of sitting side-by-side.
    var contentStyle = stacked
      ? Object.assign({}, expandedStyles.content, { flexDirection: 'column', gap: 16, maxWidth: '100%', padding: 0 })
      : expandedStyles.content;

    if (parts.length === 0) {
      return (
        <div style={expandedStyles.loading}>
          <p>{t('noPartsData')}</p>
        </div>
      );
    }

    var showPrices = chainShowsPrices(this.props.user, this.props.selectedChainId);

    return (
      <div style={contentStyle}>
        <div style={expandedStyles.section}>
          <p style={expandedStyles.sectionTitle}>
            {t('chainPartsSection')} ({chainParts.length})
          </p>
          {chainParts.length > 0 ? (
            chainParts.map(function (part) {
              return renderReservationPartRow(part, true, t('chainPartTooltip'), showPrices);
            })
          ) : (
            <p style={expandedStyles.noParts}>-</p>
          )}
        </div>
        <div style={expandedStyles.section}>
          <p style={expandedStyles.sectionTitle}>
            {t('otherPartsSection')} ({otherParts.length})
          </p>
          {otherParts.length > 0 ? (
            otherParts.map(function (part) {
              return renderReservationPartRow(part, false, t('otherPartTooltip'), showPrices);
            })
          ) : (
            <p style={expandedStyles.noParts}>-</p>
          )}
        </div>
      </div>
    );
  };

  applyOrdering = (newOrdering) => {
    this.setState({ ordering: newOrdering, page: 1 }, () => {
      this.saveListStateToStorage();
      this.refetchReservations();
    });
  };

  getSortableFields = () => {
    const { t } = this.props;
    return [
      { label: t('headingRegNr'), field: 'reg_nr' },
      { label: t('headingWorkshop'), field: 'workshop__name' },
      { label: t('headingStartTime'), field: 'start' },
      { label: t('headingEndTime'), field: 'end' },
      { label: t('headingCreatedAt'), field: 'autofutur_created' },
    ];
  };

  getCardFaceFields = (reservation) => {
    const { t } = this.props;
    var fields = [];
    if (reservation.organization_name) { fields.push({ label: t('headingOrganization'), value: reservation.organization_name }); }
    if (reservation.workshop_name) { fields.push({ label: t('headingWorkshop'), value: reservation.workshop_name }); }
    if (reservation.start) { fields.push({ label: t('headingStartTime'), value: moment(reservation.start).format('DD.MM.YYYY HH:mm') }); }
    if (reservation.description) { fields.push({ label: t('headingDescription'), value: reservation.description }); }
    return fields;
  };

  getCardAllFields = (reservation) => {
    const { t } = this.props;
    var pctValue = reservation.chain_parts_percentage != null ? Number(reservation.chain_parts_percentage) : null;
    var fields = [
      { label: t('headingRegNr'), value: [reservation.reg_nr, [reservation.manufacturer, reservation.model_name].filter(Boolean).join(' ')].filter(Boolean).join(' · ') || '-' },
      { label: t('headingOrganization'), value: reservation.organization_name || '-' },
      { label: t('headingWorkshop'), value: reservation.workshop_name || '-' },
      { label: t('headingStartTime'), value: reservation.start ? moment(reservation.start).format('DD.MM.YYYY HH:mm') : '-' },
      { label: t('headingEndTime'), value: reservation.end ? moment(reservation.end).format('DD.MM.YYYY HH:mm') : '-' },
      { label: t('headingDescription'), value: reservation.description || '-' },
      { label: t('headingCreatedAt'), value: reservation.autofutur_created ? moment(reservation.autofutur_created).format('DD.MM.YYYY') : '-' },
      { label: t('headingBooker'), value: reservation.user_name || reservation.user_id || '-' },
      { label: t('headingPartsOrdered'), value: reservation.part_items_ordered ? t('yes', { ns: 'common' }) : t('no', { ns: 'common' }) },
      { label: t('headingLatestKm'), value: reservation.latest_km ? Number(reservation.latest_km).toLocaleString('fi-FI') + ' km' : '-' },
      { label: t('headingLastMaintenance'), value: reservation.last_maintenance_date ? moment(reservation.last_maintenance_date).format('DD.MM.YYYY') : '-' },
    ];
    if (chainShowsPrices(this.props.user, this.props.selectedChainId)) {
      fields.push({ label: t('headingReservationPartsPercentage'), value: (pctValue != null && reservation.total_parts_count > 0) ? pctValue.toFixed(1) + ' %' : '-' });
    }
    var approvalText = '-';
    var labelSets = this.getApprovalLabelSets();
    var approvalParts = (reservation.approval_requests || []).map(function (ar) {
      var sentAt = ar.created_at ? ' ' + moment(ar.created_at).format('D.M.') : '';
      return (labelSets.chain[ar.approval_status] || ar.approval_status) + sentAt;
    }).concat((reservation.customer_approval_requests || []).map(function (ar) {
      var sentAt = ar.created_at ? ' ' + moment(ar.created_at).format('D.M.') : '';
      return (labelSets.customer[ar.approval_status] || ar.approval_status) + sentAt;
    }));
    if (approvalParts.length) {
      approvalText = approvalParts.join(', ');
    }
    fields.push({ label: t('headingApprovalStatus'), value: approvalText });
    return fields;
  };

  getCardOptions = (reservation) => {
    const { t, history } = this.props;
    var options = [];
    if (reservation.vehicle) {
      options.push({
        label: t('viewReservation'),
        icon: 'pi pi-arrow-right',
        command: () => { history.push('/vehicle/' + reservation.vehicle + '/reservations/' + reservation.id + '/'); },
      });
    }
    options.push({
      label: t('approvalRequestButton', { defaultValue: 'Lupapyyntö' }),
      icon: 'pi pi-send',
      command: () => { this.openSingleApprovalModal(reservation); },
    });
    return options;
  };

  renderCard = (reservation) => {
    const { t } = this.props;
    var title = reservation.vehicle
      ? (
        <Link to={'/vehicle/' + reservation.vehicle + '/'} style={{ color: '#80D8FF', textDecoration: 'none' }}>
          {reservation.reg_nr || '-'}
        </Link>
      )
      : (reservation.reg_nr || '-');
    var subtitle = [reservation.manufacturer, reservation.model_name].filter(Boolean).join(' ');
    var badges = [];
    if ((reservation.approval_requests && reservation.approval_requests.length)
        || (reservation.customer_approval_requests && reservation.customer_approval_requests.length)) {
      badges.push(this.getApprovalBadge(reservation));
    }
    return (
      <CBMobileCard
        key={reservation.id}
        title={title}
        dialogTitle={reservation.reg_nr || '-'}
        subtitle={subtitle}
        selected={this.state.selectedReservations.includes(reservation.id)}
        onSelectChange={() => this.toggleReservationSelected(reservation.id)}
        badges={badges}
        fields={this.getCardFaceFields(reservation)}
        allFields={this.getCardAllFields(reservation)}
        options={this.getCardOptions(reservation)}
        expandLabel={t('cardParts')}
        expandableContent={this.renderExpandedParts(reservation, true)}
        onExpand={() => this.ensureReservationPartsLoaded(reservation)}
      />
    );
  };

  renderMobileList = (screenSize) => {
    const { t, maintenanceReservations, maintenanceReservationsStatus } = this.props;
    if (maintenanceReservationsStatus && maintenanceReservationsStatus.loading) {
      return (
        <div style={getStyle(screenSize, styles, 'loadingContainer')}>
          <p style={getStyle(screenSize, styles, 'loadingText')}>{t('loading', { ns: 'common' })}</p>
        </div>
      );
    }
    return (
      <div style={getStyle(screenSize, styles, 'mobileListContainer')}>
        <CBMobileSortSelect
          fields={this.getSortableFields()}
          ordering={this.state.ordering}
          onChange={this.applyOrdering}
        />
        {maintenanceReservations && maintenanceReservations.length > 0 ? (
          maintenanceReservations.map((reservation) => this.renderCard(reservation))
        ) : (
          <div style={getStyle(screenSize, styles, 'mobileEmpty')}>
            {t('noReservationsFound')}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { maintenanceReservations, maintenanceReservationsStatus, t, selectedChainId } = this.props;
    const { search, filters, fields, selectedFields, selectedReservations, approvalModalIsOpen, expandedRowId } = this.state;
    var showPrices = chainShowsPrices(this.props.user, this.props.selectedChainId);
    var colSpanCount = this.getVisibleColumnCount();

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'topBarsContainer')}>
              <div style={getStyle(screenSize, styles, 'filterContainer')}>
                <div style={getStyle(screenSize, styles, 'filterRow')}>
                  <CBSearchInput
                    containerStyle={getStyle(screenSize, styles, 'searchInput')}
                    changeSearchTerms={this.changeSearchTerms}
                    onBlur={() => this.refetchReservations()}
                    value={search}
                  />

                  <div className='datepicker-dark' style={getStyle(screenSize, styles, 'datepickerWrapper')}>
                    <span style={styles.default.datepickerLabel}>{t('filterStartFrom')}</span>
                    <CBDatePickerInput
                      displayedDate={filters.start__gte ? moment(filters.start__gte) : moment()}
                      type='date'
                      dateFormat={finnishDateFormat}
                      changeDate={(value) => {
                        var newFilters = { ...filters };
                        if (value) {
                          newFilters.start__gte = moment(value).format('YYYY-MM-DD');
                        } else {
                          delete newFilters.start__gte;
                        }
                        this.setState({ filters: newFilters }, () => {
                          this.saveListStateToStorage();
                          this.refetchReservations();
                        });
                      }}
                    />
                  </div>

                  <div className='datepicker-dark' style={getStyle(screenSize, styles, 'datepickerWrapper')}>
                    <span style={styles.default.datepickerLabel}>{t('filterStartTo')}</span>
                    <CBDatePickerInput
                      displayedDate={filters.start__lte ? moment(filters.start__lte) : null}
                      type='date'
                      dateFormat={finnishDateFormat}
                      changeDate={(value) => {
                        var newFilters = { ...filters };
                        if (value) {
                          newFilters.start__lte = moment(value).format('YYYY-MM-DD');
                        } else {
                          delete newFilters.start__lte;
                        }
                        this.setState({ filters: newFilters }, () => {
                          this.saveListStateToStorage();
                          this.refetchReservations();
                        });
                      }}
                    />
                  </div>

                  <CBSelectFilters
                    name='workshop_id'
                    options={this.getWorkshopOptions()}
                    onChange={(changedFilters) => {
                      var newFilters = { ...filters };
                      if (changedFilters.workshop_id) {
                        newFilters.workshop_id = changedFilters.workshop_id;
                      } else {
                        delete newFilters.workshop_id;
                      }
                      this.setState({ filters: newFilters }, () => {
                        this.saveListStateToStorage();
                        this.refetchReservations();
                      });
                    }}
                    value={filters.workshop_id || ''}
                    selectStyle={getStyle(screenSize, styles, 'selectFilter')}
                  />

                  <CBSelectFilters
                    name='organization_id'
                    options={this.getOrganizationOptions()}
                    onChange={(changedFilters) => {
                      var newFilters = { ...filters };
                      if (changedFilters.organization_id) {
                        newFilters.organization_id = changedFilters.organization_id;
                      } else {
                        delete newFilters.organization_id;
                      }
                      this.setState({ filters: newFilters }, () => {
                        this.saveListStateToStorage();
                        this.refetchReservations();
                      });
                    }}
                    value={filters.organization_id || ''}
                    selectStyle={getStyle(screenSize, styles, 'selectFilter')}
                  />
                </div>

                <div style={getStyle(screenSize, styles, 'actionBar')}>
                  <div style={getStyle(screenSize, styles, 'countTextContainer')}>
                    <p style={getStyle(screenSize, styles, 'selectedCountText')}>
                      {t('selectedCount', { count: selectedReservations.length })}
                    </p>
                  </div>
                  <div style={{ marginLeft: 16 }}>
                    <CBButtonGarageAction
                      onClick={this.openApprovalRequestModal}
                      mainIcon='/img/icon_message_solid.svg'
                      text={t('approvalRequestButton', { defaultValue: 'Lupapyyntö' })}
                      disabled={selectedReservations.length < 1}
                      additionalStylesMainIcon={{ height: 25, width: 25 }}
                    />
                  </div>
                </div>

              </div>
            </div>

            {screenSize === 'small' ? (
              this.renderMobileList(screenSize)
            ) : (
            <React.Fragment>
            <div
              ref={this.topScrollRef}
              onScroll={this.handleTopScroll}
              style={getStyle(screenSize, styles, 'topScrollbar')}
              className="vehicle-table-scrollbar"
            >
              <div style={getStyle(screenSize, styles, 'topScrollbarInner')} />
            </div>
            <div
              ref={this.tableScrollRef}
              onScroll={this.handleTableScroll}
              style={getStyle(screenSize, styles, 'tableContainer')}
              className="vehicle-table-scrollbar"
            >
              {maintenanceReservationsStatus && maintenanceReservationsStatus.loading ? (
                <div style={getStyle(screenSize, styles, 'loadingContainer')}>
                  <p style={getStyle(screenSize, styles, 'loadingText')}>Ladataan...</p>
                </div>
              ) : (
                <table style={getStyle(screenSize, styles, 'table')}>
                  <thead>
                    <tr>
                      <th style={styleMerge(
                        getStyle(screenSize, styles, 'tableHeaderFirst'),
                        getStyle(screenSize, styles, 'alignCenter')
                      )}>
                        <CBLabelAndCheckbox
                          checked={maintenanceReservations && selectedReservations.length === maintenanceReservations.length && maintenanceReservations.length > 0}
                          additionalStyles={{ justifyContent: 'center' }}
                          onChange={this.selectAllChanged}
                        />
                      </th>

                      {selectedFields.includes('reg_nr') && (
                        <VehicleListTh
                          text={t('headingRegNr')}
                          fieldName='reg_nr'
                          orderingSymbol={this.getOrderingSymbol('reg_nr')}
                          changeOrdering={() => {
                            this.changeOrdering('reg_nr');
                          }}
                        />
                      )}

                      {selectedFields.includes('organization_name') && (
                        <VehicleListTh
                          text={t('headingOrganization')}
                          fieldName='organization'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('workshop_name') && (
                        <VehicleListTh
                          text={t('headingWorkshop')}
                          fieldName='workshop__name'
                          orderingSymbol={this.getOrderingSymbol('workshop__name')}
                          changeOrdering={() => {
                            this.changeOrdering('workshop__name');
                          }}
                        />
                      )}

                      {selectedFields.includes('start') && (
                        <VehicleListTh
                          text={t('headingStartTime')}
                          fieldName='start'
                          orderingSymbol={this.getOrderingSymbol('start')}
                          changeOrdering={() => {
                            this.changeOrdering('start');
                          }}
                        />
                      )}

                      {selectedFields.includes('end') && (
                        <VehicleListTh
                          text={t('headingEndTime')}
                          fieldName='end'
                          orderingSymbol={this.getOrderingSymbol('end')}
                          changeOrdering={() => {
                            this.changeOrdering('end');
                          }}
                        />
                      )}

                      {selectedFields.includes('description') && (
                        <VehicleListTh
                          text={t('headingDescription')}
                          fieldName='description'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('autofutur_created') && (
                        <VehicleListTh
                          text={t('headingCreatedAt')}
                          fieldName='autofutur_created'
                          orderingSymbol={this.getOrderingSymbol('autofutur_created')}
                          changeOrdering={() => {
                            this.changeOrdering('autofutur_created');
                          }}
                        />
                      )}

                      {selectedFields.includes('user_id') && (
                        <VehicleListTh
                          text={t('headingBooker')}
                          fieldName='user_id'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('part_items_ordered') && (
                        <VehicleListTh
                          text={t('headingPartsOrdered')}
                          fieldName='part_items_ordered'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('latest_km') && (
                        <VehicleListTh
                          text={t('headingLatestKm')}
                          fieldName='latest_km'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('last_maintenance') && (
                        <VehicleListTh
                          text={t('headingLastMaintenance')}
                          fieldName='last_maintenance'
                          notSortable
                        />
                      )}

                      {showPrices && selectedFields.includes('chain_parts_percentage') && (
                        <VehicleListTh
                          text={t('headingReservationPartsPercentage')}
                          fieldName='chain_parts_percentage'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('approval_status') && (
                        <VehicleListTh
                          text={t('headingApprovalStatus')}
                          fieldName='approval_status'
                          notSortable
                        />
                      )}

                      {selectedFields.includes('new_approval_request') && (
                        <VehicleListTh
                          text={t('headingNewApprovalRequest')}
                          fieldName='new_approval_request'
                          notSortable
                        />
                      )}

                      <th style={getStyle(screenSize, styles, 'tableHeaderSettings')}>
                        <MultiSelect
                          value={selectedFields}
                          onChange={(e) => this.setSelectedFields(e.value)}
                          options={showPrices ? fields : fields.filter(function (f) { return f.value !== 'chain_parts_percentage'; })}
                          className="bars"
                          dropdownIcon={undefined}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {maintenanceReservations && maintenanceReservations.length > 0 ? (
                      maintenanceReservations.map((reservation) => {
                        var isExpanded = expandedRowId === reservation.id;
                        var pctValue = reservation.chain_parts_percentage != null ? Number(reservation.chain_parts_percentage) : null;
                        return (
                          <React.Fragment key={reservation.id}>
                            <tr
                              style={{
                                ...getStyle(screenSize, styles, 'tableRow'),
                                backgroundColor: isExpanded ? 'rgba(0, 149, 218, 0.12)' : undefined,
                              }}
                              onClick={() => this.toggleRow(reservation)}
                            >
                              <td
                                style={getStyle(screenSize, styles, 'tableCheckboxTd')}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <CBLabelAndCheckbox
                                  color='white'
                                  checked={selectedReservations.includes(reservation.id)}
                                  onChange={() => this.toggleReservationSelected(reservation.id)}
                                />
                              </td>

                              {selectedFields.includes('reg_nr') && (
                                <VehicleListTd
                                  textPrimary={
                                    <span>
                                      <img
                                        src={isExpanded ? '/img/up_arrow_icon.svg' : '/img/down_arrow_icon.svg'}
                                        alt=''
                                        style={{ width: 14, height: 14, marginRight: 8, opacity: 0.5, verticalAlign: 'middle' }}
                                      />
                                      {reservation.vehicle
                                        ? <Link
                                            to={'/vehicle/' + reservation.vehicle + '/'}
                                            onClick={function (e) { e.stopPropagation(); }}
                                            style={{ color: '#80D8FF', textDecoration: 'none' }}
                                          >
                                            {reservation.reg_nr}
                                          </Link>
                                        : reservation.reg_nr
                                      }
                                    </span>
                                  }
                                  textSecondary={[reservation.manufacturer, reservation.model_name].filter(Boolean).join(' ')}
                                  additionalStylesPrimaryText={{ fontSize: 24 }}
                                />
                              )}

                              {selectedFields.includes('organization_name') && (
                                <VehicleListTd
                                  textPrimary={reservation.organization_name || '-'}
                                />
                              )}

                              {selectedFields.includes('workshop_name') && (
                                <VehicleListTd
                                  textPrimary={reservation.workshop_name || '-'}
                                />
                              )}

                              {selectedFields.includes('start') && (
                                <VehicleListTd
                                  textPrimary={reservation.start ? moment(reservation.start).format('DD.MM.YYYY HH:mm') : '-'}
                                />
                              )}

                              {selectedFields.includes('end') && (
                                <VehicleListTd
                                  textPrimary={reservation.end ? moment(reservation.end).format('DD.MM.YYYY HH:mm') : '-'}
                                />
                              )}

                              {selectedFields.includes('description') && (
                                <VehicleListTd
                                  textPrimary={reservation.description || '-'}
                                />
                              )}

                              {selectedFields.includes('autofutur_created') && (
                                <VehicleListTd
                                  textPrimary={reservation.autofutur_created ? moment(reservation.autofutur_created).format('DD.MM.YYYY') : '-'}
                                />
                              )}

                              {selectedFields.includes('user_id') && (
                                <VehicleListTd
                                  textPrimary={reservation.user_name || reservation.user_id || '-'}
                                />
                              )}

                              {selectedFields.includes('part_items_ordered') && (
                                <VehicleListTd
                                  textPrimary={reservation.part_items_ordered ? t('yes', { ns: 'common' }) : t('no', { ns: 'common' })}
                                />
                              )}

                              {selectedFields.includes('latest_km') && (
                                <VehicleListTd
                                  textPrimary={reservation.latest_km ? Number(reservation.latest_km).toLocaleString('fi-FI') + ' km' : '-'}
                                  textSecondary={reservation.latest_km_date ? moment(reservation.latest_km_date).format('DD.MM.YYYY') : ''}
                                />
                              )}

                              {selectedFields.includes('last_maintenance') && (
                                <VehicleListTd
                                  textPrimary={reservation.last_maintenance_date ? moment(reservation.last_maintenance_date).format('DD.MM.YYYY') : '-'}
                                  textSecondary={reservation.last_maintenance_km ? Number(reservation.last_maintenance_km).toLocaleString('fi-FI') + ' km' : ''}
                                />
                              )}

                              {showPrices && selectedFields.includes('chain_parts_percentage') && (
                                <VehicleListTd
                                  textPrimary={pctValue != null && reservation.total_parts_count > 0
                                    ? pctValue.toFixed(1) + ' %'
                                    : '-'}
                                  additionalStylesPrimaryText={pctValue != null && reservation.total_parts_count > 0 ? {
                                    color: getPercentageColor(pctValue),
                                    fontWeight: 'bold',
                                  } : {}}
                                />
                              )}

                              {selectedFields.includes('approval_status') && (
                                <VehicleListTd
                                  textPrimary={this.getApprovalBadge(reservation)}
                                />
                              )}

                              {selectedFields.includes('new_approval_request') && (
                                <td
                                  style={getStyle(screenSize, styles, 'alignCenter')}
                                  onClick={(e) => { e.stopPropagation(); this.openSingleApprovalModal(reservation); }}
                                >
                                  <img
                                    alt='New approval request'
                                    className='opacity-and-border-on-hover'
                                    src='/img/icon_new_message.svg'
                                    style={{ cursor: 'pointer' }}
                                  />
                                </td>
                              )}

                              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                {reservation.vehicle && (
                                  <Link
                                    to={'/vehicle/' + reservation.vehicle + '/reservations/' + reservation.id + '/'}
                                    onClick={function (e) { e.stopPropagation(); }}
                                    style={styles.default.reservationLinkButton}
                                    title={t('viewReservation')}
                                  >
                                    <img
                                      src='/img/icon_arrow_right_2.svg'
                                      alt=''
                                      style={{ width: 18, height: 18, opacity: 0.7 }}
                                    />
                                  </Link>
                                )}
                              </td>
                            </tr>
                            {isExpanded && (
                              <tr>
                                <td colSpan={colSpanCount} style={expandedStyles.cell}>
                                  {this.renderExpandedParts(reservation)}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={colSpanCount} style={getStyle(screenSize, styles, 'noDataCell')}>
                          {t('noReservationsFound')}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
            </React.Fragment>
            )}

            {approvalModalIsOpen && (
              <CreateChainMessageModal
                modalIsOpen={approvalModalIsOpen}
                closeModal={this.closeApprovalRequestModal}
                chainId={selectedChainId}
                service={SERVICE_CHAIN}
                presetMessageType='approval_request'
                presetReservations={this.getSelectedReservationObjects()}
              />
            )}

            {this.state.singleApprovalModalIsOpen && this.state.singleApprovalReservation && (
              <CreateChainMessageModal
                modalIsOpen={this.state.singleApprovalModalIsOpen}
                closeModal={this.closeSingleApprovalModal}
                chainId={selectedChainId}
                service={SERVICE_CHAIN}
                presetMessageType='approval_request'
                presetReservations={[this.state.singleApprovalReservation]}
              />
            )}

            {this.state.detailModalIsOpen && this.state.detailMessage && (
              <ChainMessageDetailModal
                message={this.state.detailMessage}
                modalIsOpen={this.state.detailModalIsOpen}
                closeModal={this.closeApprovalDetailModal}
                chainMemberships={this.props.chainMemberships}
                chainCareServices={this.props.chainCareServices}
              />
            )}

          </div>
        )}
      </CBMediaQuery>
    );
  }
}

var styles = {
  default: {
    container: {
      width: '100%',
      padding: '0px 16px 0px 0px',
    },
    mobileListContainer: {
      padding: '0 16px 24px 16px',
    },
    mobileEmpty: {
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: 15,
      padding: '24px 16px',
      textAlign: 'center',
    },
    topBarsContainer: {
      paddingLeft: 16,
      paddingTop: 16,
      marginBottom: 16,
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
    filterRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: 12,
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    searchInput: {
      height: 40,
      width: 200,
      marginLeft: 0,
    },
    datepickerWrapper: {
      width: 200,
      flexShrink: 0,
    },
    datepickerLabel: {
      color: 'rgba(255, 255, 255, 0.6)',
      fontSize: 13,
      marginRight: 6,
      whiteSpace: 'nowrap',
    },
    selectFilter: {
      width: 200,
      marginLeft: 0,
      marginRight: 0,
    },
    actionBar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 8,
    },
    countTextContainer: {
      minWidth: 60,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    selectedCountText: {
      fontFamily: 'TitilliumWeb-Bold',
      color: '#FFFFFF',
      marginBottom: 0,
    },
    tableHeaderFirst: {
      left: 0,
      padding: '8px 16px',
    },
    alignCenter: {
      textAlign: 'center',
    },
    tableCheckboxTd: {
      fontFamily: 'TitilliumWeb-Bold',
      fontSize: 18,
      color: '#FFFFFF',
      left: 0,
      padding: '8px 16px 8px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto',
      marginBottom: '24px',
      paddingBottom: 16,
      position: 'relative',
    },
    table: {
      whiteSpace: 'nowrap',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    topScrollbar: {
      overflowX: 'auto',
      overflowY: 'hidden',
      width: '100%',
      marginTop: 12,
    },
    topScrollbarInner: {
      height: 1,
    },
    tableRow: {
      height: '60px',
      width: '100%',
      cursor: 'pointer',
    },
    tableHeaderSettings: {
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      padding: '8px 8px 8px 8px',
      right: 0,
    },
    tableOptionsTd: {
      right: 0,
      padding: '0 16px 0 16px',
      zIndex: 0,
    },
    reservationLinkButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: 16,
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    noDataCell: {
      padding: '24px 16px',
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: 14,
      textAlign: 'center',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 200,
    },
    loadingText: {
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: 14,
    },
  },
  medium: {
    searchInput: {
      height: 40,
      width: 180,
      marginLeft: 0,
    },
    datepickerWrapper: {
      width: 190,
      flexShrink: 0,
    },
    selectFilter: {
      width: 180,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  small: {
    container: {
      padding: 0,
    },
    topBarsContainer: {
      paddingLeft: 16,
      paddingRight: 16,
    },
    filterRow: {
      gap: 8,
    },
    searchInput: {
      height: 40,
      width: '100%',
      marginLeft: 0,
      marginTop: 12,
    },
    datepickerWrapper: {
      width: 'calc(50% - 4px)',
      flexShrink: 0,
    },
    selectFilter: {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
    },
  },
};

var expandedStyles = {
  cell: {
    padding: 0,
    backgroundColor: 'rgba(0, 149, 218, 0.06)',
    borderBottom: '2px solid rgba(0, 149, 218, 0.3)',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    gap: 32,
    padding: '16px 24px',
    whiteSpace: 'normal',
    maxWidth: 'calc(100vw - 48px)',
  },
  section: {
    flex: 1,
    minWidth: 0,
  },
  sectionTitle: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    marginBottom: 8,
    marginTop: 0,
    letterSpacing: 0.5,
  },
  noParts: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: 14,
    padding: '4px 0',
    margin: 0,
  },
  loading: {
    padding: '16px 24px',
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: 14,
  },
};

var partRowStyles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 0',
    borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    gap: 8,
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flexShrink: 0,
  },
  chainBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: '#4CAF50',
    color: '#FFF',
    fontSize: 11,
    fontWeight: 'bold',
    flexShrink: 0,
  },
  otherBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: '#F44336',
    color: '#FFF',
    fontSize: 11,
    fontWeight: 'bold',
    flexShrink: 0,
  },
  name: {
    color: '#FFF',
    fontSize: 14,
    fontFamily: 'TitilliumWeb-SemiBold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  amount: {
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: 13,
    flexShrink: 0,
  },
  typeCode: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: 12,
    fontFamily: 'monospace',
  },
  price: {
    color: '#FFF',
    fontSize: 14,
    fontFamily: 'TitilliumWeb-SemiBold',
    minWidth: 70,
    textAlign: 'right',
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    selectedChainId: state.chain.selectedChainId,
    chainMemberships: state.chain.chainMemberships,
    chainCareServices: state.chain.chainCareServices,
    maintenanceReservations: state.chain.maintenanceReservations,
    maintenanceReservationsStatus: state.chain.maintenanceReservationsStatus,
    reservationParts: state.chain.reservationParts,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchMaintenanceReservations: _fetchMaintenanceReservations,
    fetchChainCareServices: _fetchChainCareServices,
    fetchChainMemberships: _fetchChainMemberships,
    fetchReservationParts: _fetchReservationParts,
  },
)(withRouter(translate('ChainHomeView')(ChainUpcomingMaintenancesView)));
